import '$lib/i18n';
import { locale as lang } from 'svelte-i18n';
import type { PageLoad } from './$types';
import { redirect } from '@sveltejs/kit';

export const load = (({ url, data }) => {
	const locale = url.pathname.split('/')[1];

	// Set bahasa ke i18n
	lang.set(locale);

	// Cek apakah perlu redirect
	if (data?.guestinfo?.slug === locale) {
		throw redirect(307, `/en/${locale}`);
	}

	return {
		...data,
		locale,
	};
}) satisfies PageLoad;